import { useTranslation } from "react-i18next";
import { categories, mainSiteUrl } from "@/data/categories";

export default function CategoryGrid() {
  const { t } = useTranslation();

  return (
    <div>
      <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-4">
        {categories.map((cat) => (
          <a
            key={cat.key}
            href={cat.url}
            target="_blank"
            rel="noopener nofollow"
            className="group overflow-hidden rounded-lg border border-background-200/70 bg-background-50 transition hover:-translate-y-0.5 cursor-pointer"
          >
            <div className="relative h-40 w-full overflow-hidden">
              <img
                src={cat.image}
                alt={t(cat.i18nKey)}
                title={`${t(cat.i18nKey)} - Basetao Spreadsheet`}
                className="h-full w-full object-cover object-top transition duration-500 group-hover:scale-105"
              />
            </div>
            <div className="flex items-center justify-between gap-2 p-4">
              <span className="text-sm font-semibold text-foreground-900 whitespace-nowrap">{t(cat.i18nKey)}</span>
              <span className="flex h-7 w-7 shrink-0 items-center justify-center rounded-full bg-background-100 text-foreground-500 transition group-hover:bg-primary-500 group-hover:text-background-50">
                <i className="ri-arrow-right-up-line text-sm"></i>
              </span>
            </div>
          </a>
        ))}
      </div>

      <div className="mt-8 flex justify-center">
        <a
          href={mainSiteUrl}
          target="_blank"
          rel="noopener nofollow"
          className="inline-flex items-center gap-2 rounded-md border border-primary-300 bg-primary-50 px-5 py-2.5 text-sm font-semibold text-primary-700 transition hover:bg-primary-100 cursor-pointer whitespace-nowrap"
        >
          {t("categories.viewAll")}
          <i className="ri-arrow-right-up-line"></i>
        </a>
      </div>
    </div>
  );
}